import { getListIdForFilters } from '../helper';

// ACCIONES DE LISTADO DE VISITAS
export const orderListActions = {

    LOAD_ORDERS:'LOAD_ORDERS',
    LOAD_ORDERS_NEXT:'LOAD_ORDERS_NEXT',
    LOAD_ORDERS_PREV:'LOAD_ORDERS_PREV',
    UPDATE_PAGINATION:'UPDATE_PAGINATION',

    FETCH_ORDERS_SUCCESS:'FETCH_ORDERS_SUCCESS',
    FETCH_VISTIS_FAILED:'FETCH_VISTIS_FAILED',
    FETCH_ORDERS_PENDING:'FETCH_ORDERS_PENDING',

    NAVIGATE_TO_ORDER: 'NAVIGATE_TO_ORDER',

    fetchOrdersSuccess: (orderListId, {data}) => ({
      type: orderListActions.FETCH_ORDERS_SUCCESS,
      payload: {
        orderListId: orderListId,
        data
      }
    }),

    fetchOrdersFailed: error =>({
        type:orderListActions.FETCH_VISTIS_FAILED,
        payload: error
    }),

    fetchOrdersPending: orderListId =>({
        type:orderListActions.FETCH_ORDERS_PENDING,
        payload:{
          orderListId
        }
    }),

    loadOrders: (filters, orderListId) => {
      let new_filters = filters.toJS()

      return ({
        type: orderListActions.LOAD_ORDERS,
        payload: {
          orderListId: (orderListId) ? orderListId : getListIdForFilters(new_filters),
          filters: new_filters,
        }
      })
    },

    loadOrdersNext: () => ({
      type: orderListActions.LOAD_ORDERS_NEXT
    }),

    loadOrdersPrev: () => ({
      type: orderListActions.LOAD_ORDERS_PREV
    }),

    updatePagination: page => ({
      type: orderListActions.UPDATE_PAGINATION,
      payload: {
        page
      }
    }),

    navigateToOrder: ( orderId, practicaId) => {
      let search = `?orden=${orderId}`
      if (practicaId){
        search = `${search}&practica=${practicaId}`
      }

      return ({
        type: orderListActions.NAVIGATE_TO_ORDER,
        payload: {
          pathname: `/home`,
          search
        }
      })
    },
}

export const orderListRequestActions = {
    failed: orderListActions.fetchOrdersFailed,
    success: orderListActions.fetchOrdersSuccess,
    pending: orderListActions.fetchOrdersPending
}
